module.exports = __webpack_public_path__ + "fonts/Noto_Sans_SC-300-18.7c1f22f.woff2";